

// This script main duty is to trigger GTM events based on the clicked element and the template
// It also handles wishlist related events and Swym callbacks
// Wishlist events had to be triggered by listening to swym callbacks because the ui is rendered by an external app existing in shaodow DOM.
// this prevented us from using built in methods for element detection.
// also accessing the products in page or index template is done by scraping the DOM since liquid does not provide them.

document.addEventListener("click", function(event) {
  if (!window.analyzify) return;
  let path = event.path || (event.composedPath && event.composedPath()) || [event.target];
  const template = window.analyzify.shopify_template;
  window.analyzify.log(`Click on ${template} template`, 'an_find_elem', 'click');
  
  const clickedElem = event.target;
  const clickedClasses = clickedElem.className ? (typeof clickedElem.className === 'string' ? clickedElem.className : clickedElem.className.toString()) : 'none';
  window.analyzify.log('🔍 Clicked element classes: ' + clickedClasses, 'an_find_elem', 'debug');
  
  const isWishlistButton = window.analyzify.findElemInPath(path, window.analyzify.remove_from_wishlist_btn_attributes);
  if (isWishlistButton) {
    window.analyzify.log('🚫 Wishlist button detected - should not trigger variant change', 'an_find_elem', 'debug');
  }

  // Product page
      if (template === "product") {
      const atcElem = window.analyzify.findElemInPath(path, window.analyzify.addtocart_btn_attributes);
      const prodClickElem = window.analyzify.findElemInPath(path, window.analyzify.collection_prod_click_attributes);
      
      if (atcElem) {
        // Testing switch: toggle in an.analyzify.settings.liquid
        if (window.analyzify.properties.GTM.enableAddToCartOnProductPage === false) {
          window.analyzify.log('ATC analytics disabled (testing)', 'an_find_elem', 'product');
          return;
        }

        window.analyzify.log('Triggering gtmAddToCart', 'an_find_elem', 'product');
        const getProduct = window.analyzify.getProductObj;
        if (getProduct && window.analyzify.gtmAddToCart && window.analyzify?.properties?.GTM?.enableAddToCart !== false) {
          const currentVariant = window.analyzify.getVariantInput(atcElem.closest("form"));
          window.analyzify.gtmAddToCart(getProduct, currentVariant);
          
          // Trigger server-side add to cart event
          if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssAddToCart) {
            window.analyzify.ssAddToCart(getProduct, currentVariant);
          }
        }
      } else if (prodClickElem && window.analyzify.gtmSelectItem) {
        window.analyzify.log('Triggering gtmSelectItem', 'an_find_elem', 'product');
        const getProduct = window.analyzify.getProductObj;
        if (getProduct) {
          window.analyzify.gtmSelectItem(getProduct, prodClickElem);
        }
      }
    } 
    // Wishlist page - handle variant changes and add to cart clicks
    else if (template === "page" && window.location.pathname.includes('/pages/your-wishlist')) {
      
      // Check for variant button clicks (size-option elements)
      const variantElem = window.analyzify.findElemInPath(path, window.analyzify.variant_btn_attributes);
      if (variantElem) {
        // Only proceed if the actual clicked element is a size-option, not a container
        const actualClickedElement = event.target;
        const isSizeOption = actualClickedElement.classList.contains('size-option') || 
                            actualClickedElement.hasAttribute('data-size');
        
        // Only trigger if we actually clicked on a size option
        if (!isSizeOption) {
          return;
        }
        
        window.analyzify.log('Wishlist size option clicked', 'an_find_elem', 'wishlist');
        
        // Step 1: Get the product name from DOM tree
        const wishlistItem = variantElem.closest('.swymcs-wishlistplus-item');
        if (wishlistItem) {
          const titleElement = wishlistItem.querySelector('.swymcs-wishlistplus-item-title-content');
          const productName = titleElement ? titleElement.textContent.trim() : null;
          
          console.log('🔍 [WISHLIST] Found product name:', productName);
          
          if (productName) {
            // Step 2: Get product from localStorage
            try {
              const swymProductsData = localStorage.getItem('swym-products');
              if (swymProductsData) {
                const parsedData = JSON.parse(swymProductsData);
                const wishlistProducts = parsedData?.all || [];
                
                // Step 3: Find matching product by name
                const matchingProduct = wishlistProducts.find(item => {
                  const itemName = item.dt || ''; // dt is the product title in Swym data
                  return itemName.toLowerCase().includes(productName.toLowerCase()) || 
                         productName.toLowerCase().includes(itemName.toLowerCase());
                });
                
                if (matchingProduct) {
                  console.log('✅ [WISHLIST] Found matching product:', matchingProduct);
                  
                  // Step 4: Call variant change with the product
                  if (window.analyzify.gtmVariantChange) {
                    let clickedSize = null;
                    
                    if (actualClickedElement && actualClickedElement.hasAttribute('data-size')) {
                      clickedSize = actualClickedElement.getAttribute('data-size');
                    } 
                    else if (actualClickedElement && actualClickedElement.textContent) {
                      clickedSize = actualClickedElement.textContent.trim();
                    }
                    
                    // Build new variant title with clicked size
                    const currentColor = matchingProduct.vi ? matchingProduct.vi.split('/')[1] : null;
                    const newVariantTitle = currentColor ? `${clickedSize}/${currentColor}` : clickedSize;
                    
                    console.log('🔍 [WISHLIST] Building new variant title:', {
                      originalTitle: matchingProduct.vi,
                      extractedColor: currentColor,
                      clickedSize: clickedSize,
                      newTitle: newVariantTitle
                    });
                    
                    window.analyzify.gtmVariantChange({
                      id: matchingProduct.epi, // Variant ID from Swym
                      title: newVariantTitle, // NEW: Built from clicked size + color
                      source: 'wishlist_variant_change',
                      product_name: productName,
                      clicked_size: clickedSize,
                      swym_product: matchingProduct
                    });
                    analyzify.log('Variant change event triggered', 'an_find_elem', 'wishlist_variant_change');
                  } else {
                    analyzify.log('gtmVariantChange function not available', 'an_find_elem', 'wishlist_variant_change');
                  }
                } else {
                  analyzify.log('Could not find matching product in localStorage', 'an_find_elem', 'wishlist_variant_change');
                }
              } else {
                analyzify.log('No swym-products found in localStorage', 'an_find_elem', 'wishlist_variant_change');
              }
            } catch (error) {
              analyzify.log('Error processing variant change: ' + error.message, 'an_find_elem', 'wishlist_variant_change');
            }
          } else {
            analyzify.log('Could not find product name in DOM', 'an_find_elem', 'wishlist_variant_change');
          }
        } else {
          analyzify.log('Could not find wishlist item container', 'an_find_elem', 'wishlist_variant_change');
        }
      }
      
      // Handle add to cart clicks
      const atcElem = window.analyzify.findElemInPath(path, window.analyzify.addtocart_btn_attributes);
      if (atcElem) {
        window.analyzify.log('Wishlist ATC click detected', 'an_find_elem', 'wishlist');
        
        // Wait for lastAddedCartItem to be populated, then run the method
        const waitAndRun = () => {
          if (window.analyzify.lastAddedCartItem?.variant_id) {
            const variantId = window.analyzify.lastAddedCartItem.variant_id;
            
            if (typeof window.analyzify.getPageProducts === 'function') {
              window.analyzify.getPageProducts().then((pageObj) => {
                const products = pageObj?.products || [];
                const productObj = products.find(p => Array.isArray(p?.variants) && p.variants.some(v => Number(v?.id) === Number(variantId)));
                console.log("productObj", productObj)
                if (productObj && window.analyzify.gtmAddToCart && window.analyzify?.properties?.GTM?.enableAddToCart !== false) {
                  // If productObj.quantity doesn't exist, get it from the closest quantity element
                  if (!productObj.quantity) {
                    const closestQtyElement = atcElem.closest('.swymcs-wishlistplus-item')?.querySelector(`.${analyzify.wishlist_quantity_class_attribute}`);
                    if (closestQtyElement) {
                      const qtyValue = closestQtyElement.value || closestQtyElement.textContent || closestQtyElement.getAttribute('data-quantity');
                      if (qtyValue) {
                        productObj.quantity = Number(qtyValue) || 1;
                      }
                    }
                    // Fallback to default quantity if still not found
                    if (!productObj.quantity) {
                      productObj.quantity = 1;
                    }
                  }
                  
                    window.analyzify.gtmAddToCart(productObj, variantId);
                    
                    // Trigger server-side add to cart event
                    if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssAddToCart) {
                      window.analyzify.ssAddToCart(productObj, variantId);
                    }
                }
              });
            }
          } else {
            setTimeout(waitAndRun, 100);
          }
        };
        
        waitAndRun();
      }
    }
  // Generic page template (non-wishlist): resolve product via data-variant-id and pass to gtmAddToCart
  else if (template === "page") {
    const atcElem = window.analyzify.findElemInPath(path, window.analyzify.addtocart_btn_attributes);
    const variantElem = window.analyzify.findElemInPath(path, window.analyzify.variant_btn_attributes);
    
    if (atcElem) {
      window.analyzify.log('Page ATC click detected', 'an_find_elem', 'page');
      let variantId = atcElem?.dataset?.variantId || null;

      if (variantId && typeof window.analyzify.getPageProducts === 'function') {
        const formVariant = window.analyzify.getVariantInput(atcElem.closest("form"));
        const currentVariant = formVariant || variantId;
        window.analyzify.getPageProducts(variantId).then((pageObj) => {
          const products = pageObj?.products || [];
          const productObj = products.find(p => Array.isArray(p?.variants) && p.variants.some(v => Number(v?.id) === Number(variantId)));
          if (productObj && window.analyzify.gtmAddToCart && window.analyzify?.properties?.GTM?.atcOnCustomPage && window.analyzify?.properties?.GTM?.enableAddToCart !== false) {
            window.analyzify.gtmAddToCart(productObj, currentVariant);
            
            // Trigger server-side add to cart event
            if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssAddToCart) {
              window.analyzify.ssAddToCart(productObj, currentVariant);
            }
          }
        });
      }
    } else if (variantElem && window.analyzify.gtmVariantChange) {
      window.analyzify.log('🔍 Variant element detected: ' + (variantElem.className || 'none'), 'an_find_elem', 'debug');
      
      window.analyzify.log('✅ Page variant button clicked (not wishlist)', 'an_find_elem', 'page');
      window.analyzify.log('Variant element found with classes: ' + (variantElem.className || 'none'), 'an_find_elem', 'debug');
      
      const clickedSize = event.target.getAttribute('data-size') || 
                        event.target.getAttribute('data-value') || 
                        event.target.textContent?.trim();
      
      // Fix className.split error by converting className to string
      const className = event.target.className;
      const classNameString = (typeof className === 'string') ? className : 
                             (className && className.toString) ? className.toString() : '';
      
      const variantData = {
        clicked_size: clickedSize,
        source: 'page_variant_change',
        clicked_element: event.target.tagName + (classNameString ? '.' + classNameString.split(' ').join('.') : ''),
        element: variantElem
      };
      
      console.log('🔧 DEBUG: Page variant change data before gtmVariantChange call:', variantData);
      
      // Pass variant data for page variant change
      window.analyzify.gtmVariantChange(variantData);
      
      analyzify.log('DEBUG: Page variant change event triggered', 'an_find_elem', 'page_variant_change');
    }
  }
  else if (template === "cart") {  
    //is not being used. we're instead handling add_to_wishlist and remove_from_cart for move-to-wishlist btn
    //  in cart via swym callbacks in an_swym.js/ it's below
    const wishlistElem = window.analyzify.findElemInPath(path, window.analyzify.wishlist_btn_attributes);
    if (wishlistElem && window.analyzify.gtmAddToWishList) {
      // Check if this is a Swym wishlist button (has Swym classes)
      const isSwymWishlistButton = wishlistElem.classList.contains('js-move-to-wishlist') || 
                                   wishlistElem.classList.contains('unsub-cart-item-wishlist') ||
                                   wishlistElem.closest('.js-move-to-wishlist, .unsub-cart-item-wishlist');
      
      // Skip click-based handling for Swym buttons as they're handled by Swym callbacks
      if (isSwymWishlistButton) {
        window.analyzify.log('Skipping click-based wishlist handling - Swym button detected', 'an_find_elem', 'cart');
        return;
      }
      
      setTimeout(() => {
          fetch("/cart.js").then(r => r.json()).then(cart => {
            let cartItem = null;
 
            if (!cartItem && wishlistElem.getAttribute("data-product-id")) {
            const productId = wishlistElem.getAttribute("data-product-id");
            cartItem = cart.items.find(item => item.product_id.toString() === productId);
          }

          if (!cartItem && wishlistElem.getAttribute("data-variant-id")) {
            const variantId = wishlistElem.getAttribute("data-variant-id");
            cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
          }
 
          if (cartItem) {
            const productObj = {
              product: {
                id: cartItem.product_id,
                title: cartItem.product_title,
                price: cartItem.price,
                vendor: cartItem.vendor,
                type: cartItem.product_type,
                tags: cartItem.product_tags || [],
                variants: [{
                  id: cartItem.variant_id,
                  title: cartItem.variant_title,
                  price: cartItem.price,
                  sku: cartItem.sku
                }]
              }
            };
            
            window.analyzify.gtmAddToWishList(productObj, cartItem.variant_id);
            
            // Also trigger remove from cart since this is a "move to wishlist" action
            if (window.analyzify.gtmRemoveFromCart) {
              window.analyzify.gtmRemoveFromCart(cartItem);
            }
          } else {
            console.warn("Could not find matching cart item for wishlist button");
          }
        }).catch(err => {
          console.error("Error fetching cart data for wishlist:", err);
        });
      }, 800);
    }
  }
  // Collection page
  else if (template === "collection") {
    const prodClickElem = window.analyzify.findElemInPath(path, window.analyzify.collection_prod_click_attributes);
    const atcElem = window.analyzify.findElemInPath(path, window.analyzify.collection_atc_attributes);
    const wishlistElem = window.analyzify.findElemInPath(path, window.analyzify.wishlist_btn_attributes);
    const variantElem = window.analyzify.findElemInPath(path, window.analyzify.variant_btn_attributes);
    
    if (prodClickElem && window.analyzify.getCollectionObj && window.analyzify.gtmSelectItem) {
      window.analyzify.log('Triggering gtmSelectItem', 'an_find_elem', 'collection');
      const clickedProduct = window.analyzify.findClickedProduct(prodClickElem, window.analyzify.getCollectionObj.products);
      if (clickedProduct) window.analyzify.gtmSelectItem(clickedProduct, prodClickElem);
    } else if (atcElem && window.analyzify.getCollectionObj && window.analyzify.gtmAddToCart && window.analyzify?.properties?.GTM?.enableAddToCart !== false) {
       window.analyzify.log('Triggering gtmAddToCart', 'an_find_elem', 'collection');
       const addedProduct = window.analyzify.findClickedProduct(atcElem, window.analyzify.getCollectionObj.products);
       if (addedProduct) {
         const currentVariant = addedProduct.variants[0]?.id || null;
         window.analyzify.gtmAddToCart(addedProduct, currentVariant);
         
         // Trigger server-side add to cart event
         if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssAddToCart) {
           window.analyzify.ssAddToCart(addedProduct, currentVariant);
         }
       }
     } else if (variantElem && window.analyzify.gtmVariantChange) {

      window.analyzify.log('Collection variant button clicked', 'an_find_elem', 'collection');
       
      const clickedSize = event.target.getAttribute('data-size') || 
                        event.target.getAttribute('data-value') || 
                        event.target.textContent?.trim();
      
      const variantData = {
        clicked_size: clickedSize,
        source: 'collection_variant_change',
        clicked_element: event.target.tagName + (event.target.className ? '.' + event.target.className.split(' ').join('.') : ''),
        element: variantElem
      };
            
      // Pass simple variant data 
      window.analyzify.gtmVariantChange(variantData);
      
      analyzify.log('DEBUG: Collection variant change event triggered', 'an_find_elem', 'collection_variant_change');
    } else if (wishlistElem && window.analyzify.getCollectionObj && window.analyzify.gtmAddToWishList) {
      window.analyzify.log('Triggering gtmAddToWishList', 'an_find_elem', 'collection');
      const addedProduct = window.analyzify.findClickedProduct(wishlistElem, window.analyzify.getCollectionObj.products);
      if (addedProduct) {
        const currentVariant = addedProduct.variants[0]?.id || null;
        window.analyzify.gtmAddToWishList(addedProduct, currentVariant);
      }
    }
  }
  //homepage
  else if (template === "index") {
    const atcElem = window.analyzify.findElemInPath(path, window.analyzify.addtocart_btn_attributes);
    const variantElem = window.analyzify.findElemInPath(path, window.analyzify.variant_btn_attributes);
    
    if (atcElem && window.analyzify.gtmAddToCart) {
      window.analyzify.log('Triggering gtmAddToCart', 'an_find_elem', 'homepage');
      const variantId = atcElem.dataset.variantId;
      if (variantId && typeof window.analyzify.getPageProducts === 'function') {
        window.analyzify.getPageProducts().then((pageObj) => {
          const products = pageObj?.products || [];
          const productObj = products.find(p => Array.isArray(p?.variants) && p.variants.some(v => Number(v?.id) === Number(variantId)));
          if (productObj && window.analyzify.gtmAddToCart && window.analyzify?.properties?.GTM?.atcOnHomePage && window.analyzify?.properties?.GTM?.enableAddToCart !== false) {
            window.analyzify.gtmAddToCart(productObj, variantId);
            
            // Trigger server-side add to cart event
            if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssAddToCart) {
              window.analyzify.ssAddToCart(productObj, variantId);
            }
          }
        });
      }
    } else if (variantElem && window.analyzify.gtmVariantChange) {
      window.analyzify.log('Homepage variant button clicked', 'an_find_elem', 'index');
      
      const clickedSize = event.target.getAttribute('data-size') || 
                        event.target.getAttribute('data-value') || 
                        event.target.textContent?.trim();
      
      const variantData = {
        clicked_size: clickedSize,
        source: 'homepage_variant_change',
        clicked_element: event.target.tagName + (event.target.className ? '.' + event.target.className.split(' ').join('.') : ''),
        element: variantElem
      };
      
      console.log('🔧 DEBUG: Homepage variant change data before gtmVariantChange call:', variantData);
      
      // Pass variant data for homepage variant change
      window.analyzify.gtmVariantChange(variantData);
      
      analyzify.log('DEBUG: Homepage variant change event triggered', 'an_find_elem', 'homepage_variant_change');
    }
  }

  // Search page
  else if (template === "search") {
    const prodClickElem = window.analyzify.findElemInPath(path, window.analyzify.search_prod_click_attributes);
    const atcElem = window.analyzify.findElemInPath(path, window.analyzify.addtocart_btn_attributes);
    const variantElem = window.analyzify.findElemInPath(path, window.analyzify.variant_btn_attributes);
    const wishlistElem = window.analyzify.findElemInPath(path, window.analyzify.wishlist_btn_attributes);
    
    if (prodClickElem && window.analyzify.getSearchObj && window.analyzify.gtmSelectItem) {
      window.analyzify.log('Triggering gtmSelectItem', 'an_find_elem', 'search');
      const clickedProduct = window.analyzify.findClickedProduct(prodClickElem, window.analyzify.getSearchObj.products);
      if (clickedProduct) window.analyzify.gtmSelectItem(clickedProduct);
    } else if (variantElem && window.analyzify.gtmVariantChange) {
      window.analyzify.log('Search variant button clicked', 'an_find_elem', 'search');
      
      // For search pages, use the variant ID directly from the button
      const variantId = variantElem.getAttribute('data-variant-id');
      
      // Pass variant data with the variant ID for direct lookup
      window.analyzify.gtmVariantChange({
        variant_id: variantId,
        source: 'search_variant_change',
        clicked_element: event.target.tagName + (event.target.className ? '.' + event.target.className.split(' ').join('.') : ''),
        element: variantElem
      });
    } else if (atcElem && window.analyzify.getSearchObj && window.analyzify.gtmAddToCart && window.analyzify?.properties?.GTM?.enableAddToCart !== false) {
      window.analyzify.log('Triggering gtmAddToCart', 'an_find_elem', 'search');
      const addedProduct = window.analyzify.findAddedProduct(atcElem, window.analyzify.getSearchObj.products);
      if (addedProduct) {
        const currentVariant = addedProduct.variants[0]?.id || null;
        window.analyzify.gtmAddToCart(addedProduct, currentVariant);
        
        // Trigger server-side add to cart event
        if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssAddToCart) {
          window.analyzify.ssAddToCart(addedProduct, currentVariant);
        }
      }
    } else if (wishlistElem && window.analyzify.getSearchObj && window.analyzify.gtmAddToWishList) {
      window.analyzify.log('Triggering gtmAddToWishList', 'an_find_elem', 'search');
      const addedProduct = window.analyzify.findClickedProduct(wishlistElem, window.analyzify.getSearchObj.products);
      if (addedProduct) {
        const currentVariant = addedProduct.variants[0]?.id || null;
        window.analyzify.gtmAddToWishList(addedProduct, currentVariant);
      }
    }
  }

  // Quantity increase/decrease 
  const quantityIncreaseElem = window.analyzify.findElemInPath(path, window.analyzify.quantity_increase_btn_attributes);
  const quantityDecreaseElem = window.analyzify.findElemInPath(path, window.analyzify.quantity_decrease_btn_attributes);

   if (quantityIncreaseElem && window.analyzify.gtmAddToCart && window.analyzify?.properties?.GTM?.enableAddToCart !== false) {
     window.analyzify.log('Triggering gtmAddToCart for quantity increase', 'an_find_elem', 'cart');
     setTimeout(() => {
       fetch("/cart.js").then(r => r.json()).then(cart => {
       const href = quantityIncreaseElem.getAttribute("href");
       if (href && href.includes("/cart/change?line=")) {
         const lineNumber = href.split("change?line=")[1].split("&")[0];
         const cartItem = cart.items[parseInt(lineNumber, 10) - 1];
         if (cartItem) {
           const productObj = {
             product: {
               id: cartItem.product_id,
               title: cartItem.product_title,
               price: cartItem.price,
               vendor: cartItem.vendor,
               type: cartItem.product_type,
               tags: cartItem.product_tags || [],
               variants: [{
                 id: cartItem.variant_id,
                 title: cartItem.variant_title,
                 price: cartItem.price,
                 sku: cartItem.sku
               }]
             }
           };
           window.analyzify.gtmAddToCart(
          productObj,
          cartItem.variant_id,
          window.analyzify.quantityEventOverAtc
          );
          
          // Trigger server-side add to cart event
          if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssAddToCart) {
            window.analyzify.ssAddToCart(productObj, cartItem.variant_id);
          }
         }
       }
     });
     }, 800);
     return; 
  } else if (quantityDecreaseElem && !quantityDecreaseElem.classList.contains('cart-item__remove') && window.analyzify.gtmRemoveFromCart) {
    window.analyzify.log('Triggering gtmRemoveFromCart for quantity decrease', 'an_find_elem', 'cart');
     setTimeout(() => {
       fetch("/cart.js").then(r => r.json()).then(cart => {
       const href = quantityDecreaseElem.getAttribute("href");
       if (href && href.includes("/cart/change?line=")) {
         const lineNumber = href.split("change?line=")[1].split("&")[0];
         const cartItem = cart.items[parseInt(lineNumber, 10) - 1];
         if (cartItem) {
           window.analyzify.gtmRemoveFromCart(cartItem, window.analyzify.quantityEventOverAtc);
         }
       }
     });
     }, 800);
     return; 
   }
  // Remove from cart 
  const rfcElem = window.analyzify.findElemInPath(path, window.analyzify.removefromcart_btn_attributes);
  if (rfcElem && window.analyzify.gtmRemoveFromCart) {
    window.analyzify.log('Triggering gtmRemoveFromCart', 'an_find_elem', 'cart');
    setTimeout(() => {
      fetch("/cart.js").then(r => r.json()).then(cart => {

      let removedProduct = null;
      if (rfcElem.getAttribute("alt")) {
        const productName = rfcElem.getAttribute("alt").replace("Remove ", "");
        removedProduct = cart.items.find(item => item.product_title === productName);
      } else if (rfcElem.getAttribute("data-index")) {
        const productCartOrder = rfcElem.getAttribute("data-index");
        removedProduct = cart.items[parseInt(productCartOrder, 10) - 1];
      } else if (rfcElem.getAttribute("data-id")) {
        const dataId = rfcElem.getAttribute("data-id");
        removedProduct = cart.items.find(item => item.id.toString() === dataId);
      }
      if (!removedProduct) {
        const attrValues = rfcElem.getAttributeNames().map(name => rfcElem.getAttribute(name));
        attrValues.forEach(val => {
          if (val && val.match(/([0-9]+)/g)) {
            val.match(/([0-9]+)/g).forEach(id => {
              const found = cart.items.find(item => item.variant_id == Number(id));
              if (found) removedProduct = found;
            });
          }
        });
      } 

        if (!removedProduct) {
          const href = rfcElem.getAttribute("href");
          if (href && href.includes("/cart/change?line=")) {
         const lineNumber = href.split("change?line=")[1].split("&")[0];
         removedProduct = cart.items[parseInt(lineNumber, 10) - 1];
       }
        }
        
      if (removedProduct) {
        window.analyzify.gtmRemoveFromCart(removedProduct);
      } else {
        console.log("removedProduct not found")
      }
    });
    }, 800);
  }


  // Begin checkout (fetch cart and pass to GTM)
  const checkoutElem = window.analyzify.findElemInPath(path, window.analyzify.checkout_btn_attributes);
  if (checkoutElem && window.analyzify.gtmBeginCheckout && window.analyzify?.properties?.GTM?.enableBeginCheckout !== false) {
    window.analyzify.log('Triggering gtmBeginCheckout', 'an_find_elem', 'checkout');
    
    // Fetch cart and trigger gtmBeginCheckout immediately
    fetch("/cart.js").then(r => r.json()).then(cart => {
      window.analyzify.gtmBeginCheckout(cart);
      
      // Trigger server-side begin checkout event
      if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssBeginCheckout) {
        window.analyzify.ssBeginCheckout(cart);
      }
    }).catch(err => {
      window.analyzify.log('Error fetching cart for gtmBeginCheckout: ' + (err?.message || err), 'an_find_elem', 'checkout');
    });
  }

const navResult = window.analyzify.findNavChildrenElemInPath(path, window.analyzify.header_nav_btn_attributes);
analyzify.log(`Navigation result from findNavChildrenElemInPath:`, 'an_find_elem', 'nav');
analyzify.log(navResult, 'an_find_elem', 'nav');

if (navResult && window.analyzify.gtmNavClick) {
  window.analyzify.log('Triggering gtmNavClick', 'an_find_elem', 'nav');
  // Determine the navigation type based on matched class
  const navigationType = navResult.matchedClass === 'main-nav' ? 'mega_mobile' : 'mega';
  
  // Pass the navDetail directly to gtmNavClick to avoid timing issues
  window.analyzify.gtmNavClick(navResult.element, navigationType, navResult.navDetail);
}

  // Contact form submit
  const contactFormElem = window.analyzify.findElemInPath(path, window.analyzify.contactForm_btn_attributes);
  if (contactFormElem && window.analyzify.gtmsubmitContactForm) {
    // Only fire contact form events if we're on the email-us page
    const currentPath = window.location.pathname;
    const isEmailUsPage = currentPath === '/pages/email-us';
    
    if (!isEmailUsPage) {
      return;
    }
    window.analyzify.gtmsubmitContactForm(contactFormElem);
  }
  // Newsletter form submit
  const newsletterFormElem = window.analyzify.findElemInPath(path, window.analyzify.submitNewsletterForm_btn_attributes);
  if (newsletterFormElem && window.analyzify.gtmsubmitNewsletterForm) {
    window.analyzify.log('Triggering gtmsubmitNewsletterForm', 'an_find_elem', 'newsletter');
    window.analyzify.gtmsubmitNewsletterForm(newsletterFormElem);
  }
  // Search form submit
  const searchActionElem = window.analyzify.findElemInPath(path, window.analyzify.search_action_attributes);
  if (searchActionElem && window.analyzify.gtmSearchAction) {
    window.analyzify.log('Triggering gtmSearchAction', 'find_elem', 'click');
    // Find the search form and get the search term
    const searchForm = searchActionElem.closest('form');
    if (searchForm) {
      const searchInput = searchForm.querySelector('input[name="q"]');
      if (searchInput && searchInput.value.trim()) {
        window.analyzify.gtmSearchAction(searchInput.value.trim());
        
        // Trigger server-side search event
        if (window.analyzify?.properties?.SERVERSIDE?.status && window.analyzify.ssSearch) {
          window.analyzify.ssSearch({ term: searchInput.value.trim() });
        }
      }
    }
  }
});

if (window.analyzify.shopify_template === "account") {
  document.addEventListener('DOMContentLoaded', function() {
    if (window.analyzify.gtmViewAccount) {
      window.analyzify.log('Triggering gtmViewAccount on account template', 'an_find_elem', 'account');
      window.analyzify.gtmViewAccount();
    }
  });
  
  // If document is already loaded, fire immediately
  if (document.readyState !== 'loading') {
    if (window.analyzify.gtmViewAccount) {
      window.analyzify.log('Triggering gtmViewAccount on account template (immediate)', 'an_find_elem', 'account');
      window.analyzify.gtmViewAccount();
    }
  }
}

// Account creation form submit listener - aims to detect success by noticing the successful page redirection
if (window.analyzify.shopify_template === "register") {
  const setupAccountFormListener = () => {
    const accountForm = document.querySelector(`form[id="${window.analyzify.accountCreationForm_btn_attributes.form_type}"]`);
    if (accountForm && window.analyzify.gtmAccountCreation) {
      accountForm.addEventListener('submit', function(event) {
        // Store form data for potential GTM event
        const formData = new FormData(accountForm);
        const formDataForEvent = {};
        for (const [key, value] of formData.entries()) {
          formDataForEvent[key] = value;
        }
        
        // Set a flag to track form submission
        sessionStorage.setItem('account_creation_attempted', JSON.stringify({
          timestamp: Date.now(),
          formData: formDataForEvent
        }));
      });
    }
  };
  
  document.addEventListener('DOMContentLoaded', setupAccountFormListener);
  
  // If document is already loaded, fire immediately
  if (document.readyState !== 'loading') {
    setupAccountFormListener();
  }
}

// Check for successful account creation on page load (any template)
document.addEventListener('DOMContentLoaded', function() {
  const attemptData = sessionStorage.getItem('account_creation_attempted');
  
  if (attemptData) {
    try {
      const { timestamp, formData } = JSON.parse(attemptData);
      const currentTime = Date.now();
      const timeDiff = currentTime - timestamp;
      
      // Check if attempt was recent (within last 10 seconds) and we're NOT on register template
      if (timeDiff < 10000 && window.analyzify.shopify_template !== "register") {
        
        // Create a mock form element with the stored data
        const mockForm = document.createElement('form');
        for (const [key, value] of Object.entries(formData)) {
          const input = document.createElement('input');
          input.name = key;
          input.value = value;
          mockForm.appendChild(input);
        }
        
        // Trigger the GTM event with stored form data
        if (window.analyzify.gtmAccountCreation) {
          window.analyzify.log('Triggering GTM event for successful account creation');
          window.analyzify.gtmAccountCreation(mockForm);
        }
        
        // Clean up
        sessionStorage.removeItem('account_creation_attempted');
      } else if (timeDiff >= 10000) {
        // Clean up old attempts
        sessionStorage.removeItem('account_creation_attempted');
      }
    } catch (error) {
      sessionStorage.removeItem('account_creation_attempted');
    }
  }
});

// If document is already loaded, fire immediately
if (document.readyState !== 'loading') {
  const attemptData = sessionStorage.getItem('account_creation_attempted');
  
  if (attemptData) {
    try {
      const { timestamp, formData } = JSON.parse(attemptData);
      const currentTime = Date.now();
      const timeDiff = currentTime - timestamp;
      
      // Check if attempt was recent (within last 10 seconds) and we're NOT on register template
      if (timeDiff < 10000 && window.analyzify.shopify_template !== "register") {
        
        // Create a mock form element with the stored data
        const mockForm = document.createElement('form');
        for (const [key, value] of Object.entries(formData)) {
          const input = document.createElement('input');
          input.name = key;
          input.value = value;
          mockForm.appendChild(input);
        }
        
        // Trigger the GTM event with stored form data
        if (window.analyzify.gtmAccountCreation) {
          window.analyzify.log('Triggering GTM event for successful account creation');
          window.analyzify.gtmAccountCreation(mockForm);
        }
        
        // Clean up
        sessionStorage.removeItem('account_creation_attempted');
      } else if (timeDiff >= 10000) {
        // Clean up old attempts
        sessionStorage.removeItem('account_creation_attempted');
      }
    } catch (error) {
      sessionStorage.removeItem('account_creation_attempted');
    }
  }
}

  // initialize SwymCallbacks for wishlist related events
     if (!window.SwymCallbacks) window.SwymCallbacks = [];
   
   window.SwymCallbacks.push(function(swatInstance) {

     if (swatInstance && swatInstance.evtLayer && swatInstance.JSEvents && swatInstance.JSEvents.addedToWishlist) {
      window.analyzify.log('SwymCallbacks initialized', 'an_find_elem', 'swym');
      // console.log("swym events", swatInstance.JSEvents)
       try {
          swatInstance.evtLayer.addEventListener(
            swatInstance.JSEvents.addedToWishlist,
            function(evt) {
              console.log("swym added to wishlist", evt)
             const data = evt?.detail?.d || {};
             console.log("wsymdata", data)
             try {

               let productInput = null;
               let variantId = null;

               // 1) Product page context
               if (window.analyzify?.getProductObj?.product) {
                 productInput = window.analyzify.getProductObj; 
                 variantId = window.analyzify.getProductObj?.variant?.id || null;
               }

               // 2) If not on PDP, try to resolve from collection by Swym product id
               if (!productInput && (data?.empi || data?.id)) {
                 const swymProdId = Number(data.empi || data.id);
                 
                 if (window.analyzify?.getCollectionObj?.products) {
                   const found = window.analyzify.getCollectionObj.products?.find(p => Number(p?.id) === swymProdId);
                   if (found) {
                     productInput = found; 
                   }
                 }
                 
                 // 2b) Search page context - check if we have search results
                 if (!productInput && window.analyzify?.getSearchObj?.products) {
                   const found = window.analyzify.getSearchObj.products?.find(p => Number(p?.id) === swymProdId);
                   if (found) {
                     productInput = found;
                   }
                 }
               }

               // 2c) Cart page context - check if we have cart items and can find the product
               if (!productInput && window.analyzify?.detectedCart?.items && (data?.empi || data?.id)) {
                 const swymProdId = Number(data.empi || data.id);
                 
                 const cartItem = window.analyzify.detectedCart.items.find(item => Number(item?.product_id) === swymProdId);
                 if (cartItem) {
                   productInput = {
                     id: cartItem.product_id,
                     title: cartItem.product_title || cartItem.title,
                     vendor: cartItem.vendor || '',
                     type: cartItem.product_type || cartItem.type || '',
                     tags: [],
                     url: cartItem.url || '',
                     variants: cartItem.variant_id ? [{
                       id: cartItem.variant_id,
                       title: cartItem.variant_title || 'Default',
                       sku: cartItem.sku || '',
                       price: cartItem.price
                     }] : []
                   };
                   variantId = cartItem.variant_id;
                 }
               }
               // 3) Variant from Swym payload as fallback
               if (!variantId && (data?.epi || data?.vid)) {
                 variantId = Number(data.epi || data.vid);
               }

               if (productInput && typeof window.analyzify?.gtmAddToWishList === 'function') {
                 window.analyzify.gtmAddToWishList(productInput, variantId || null);
                 window.analyzify.log('GTM wishlist event triggered', 'an_find_elem', 'swym');
                 
                 // If on cart page, also trigger remove from cart since this is a "move to wishlist" action
                 if (window.analyzify?.shopify_template === 'cart' && window.analyzify.gtmRemoveFromCart) {
                   // Find the cart item that matches this product/variant
                   if (window.analyzify?.detectedCart?.items) {
                     const cartItem = window.analyzify.detectedCart.items.find(item => {
                       const swymProdId = Number(data.empi || data.id);
                       const swymVariantId = Number(data.epi || data.vid);
                       return Number(item?.product_id) === swymProdId || Number(item?.variant_id) === swymVariantId;
                     });
                     
                     if (cartItem) {
                       window.analyzify.gtmRemoveFromCart(cartItem);
                       window.analyzify.log('GTM remove from cart event triggered (Swym move to wishlist)', 'an_find_elem', 'swym');
                     }
                   }
                 }
               } else if (!productInput) { 
                 const isOnPageTemplate = (window.analyzify?.shopify_template === 'page');
                 const isOnIndexTemplate = (window.analyzify?.shopify_template === 'index');
                 
                 if ((isOnPageTemplate || isOnIndexTemplate) && typeof window.analyzify?.getPageProducts === 'function') {
                   const productId = Number(data.empi || data.id);
                   window.analyzify.getPageProducts(variantId).then((pageObj) => {
                     const products = pageObj?.products || [];
                     let matched = null;
                     if (variantId) {
                       matched = products.find(p => Array.isArray(p?.variants) && p.variants.some(v => Number(v?.id) === Number(variantId)));
                     }
                     if (!matched && productId) {
                       matched = products.find(p => Number(p?.id) === Number(productId));
                     }
                     window.analyzify.gtmAddToWishList(matched || productInput || { id: productId }, variantId || null);
                   });
                 }
               } else {
                 console.warn('Wishlist listener: product context not found for GTM push or gtmAddToWishList not available');
                 console.warn('productInput:', productInput);
                 console.warn('gtmAddToWishList available:', typeof window.analyzify?.gtmAddToWishList);
               }
             } catch (err) {
               window.analyzify.log('Wishlist listener error', 'an_find_elem', 'swym');
             }
            }
           );

          // For remove from wishlist events 
          if (swatInstance.JSEvents.removedFromWishlist) {
            swatInstance.evtLayer.addEventListener(
              swatInstance.JSEvents.removedFromWishlist,
              function(evt) {
                try {
                  const data = evt?.detail?.d || {};
                  const productId = Number(data.empi || data.id) || null;
                  const variantId = Number(data.epi || data.vid) || null;
                  
                  let productInput = null;
                  
                  // Get product context
                  if (window.analyzify?.getProductObj?.product) {
                    productInput = window.analyzify.getProductObj;
                  } else if (window.analyzify?.getCollectionObj?.products && productId) {
                    const found = window.analyzify.getCollectionObj.products.find(p => Number(p?.id) === productId);
                    if (found) productInput = found;
                  }
                  
                  // If on page template, resolve product via getPageProducts
                  const isOnPageTemplate = (window.analyzify?.shopify_template === 'page');
                  if (isOnPageTemplate && typeof window.analyzify?.getPageProducts === 'function') {
                    window.analyzify.getPageProducts(variantId).then((pageObj) => {
                      const products = pageObj?.products || [];
                      let matched = null;
                      if (variantId) {
                        matched = products.find(p => Array.isArray(p?.variants) && p.variants.some(v => Number(v?.id) === Number(variantId)));
                      }
                      if (!matched && productId) {
                        matched = products.find(p => Number(p?.id) === Number(productId));
                      }
                      if (typeof window.analyzify?.gtmRemoveFromWishList === 'function') {
                        window.analyzify.gtmRemoveFromWishList(matched || productInput || { id: productId }, variantId || null);
                      }
                    }).catch(() => {
                      if (typeof window.analyzify?.gtmRemoveFromWishList === 'function') {
                        window.analyzify.gtmRemoveFromWishList(productInput || { id: productId }, variantId || null);
                      }
                    });
                    return;
                  }
                  
                  // For search template
                  if (window.analyzify?.shopify_template === 'search' && window.analyzify?.getSearchObj?.products) {
                    const searchProducts = window.analyzify.getSearchObj.products;
                    let matched = null;
                    if (variantId) {
                      matched = searchProducts.find(p => p?.variants?.some(v => Number(v?.id) === Number(variantId)));
                    }
                    if (!matched && productId) {
                      matched = searchProducts.find(p => Number(p?.id) === Number(productId));
                    }
                    if (matched && window.analyzify?.gtmRemoveFromWishList) {
                      window.analyzify.gtmRemoveFromWishList(matched, variantId || null);
                    }
                    return;
                  }
                  
                  // For index template, resolve product via getPageProducts
                  const isOnIndexTemplate = (window.analyzify?.shopify_template === 'index');
                  if (isOnIndexTemplate && typeof window.analyzify?.getPageProducts === 'function') {
                    window.analyzify.getPageProducts(variantId).then((pageObj) => {
                      const products = pageObj?.products || [];
                      let matched = null;
                      if (variantId) {
                        matched = products.find(p => Array.isArray(p?.variants) && p.variants.some(v => Number(v?.id) === Number(variantId)));
                      }
                      if (!matched && productId) {
                        matched = products.find(p => Number(p?.id) === Number(productId));
                      }
                      if (typeof window.analyzify?.gtmRemoveFromWishList === 'function') {
                        window.analyzify.gtmRemoveFromWishList(matched || productInput || { id: productId }, variantId || null);
                      }
                    }).catch(() => {
                      if (typeof window.analyzify?.gtmRemoveFromWishList === 'function') {
                        window.analyzify.gtmRemoveFromWishList(productInput || { id: productId }, variantId || null);
                      }
                    });
                    return;
                  }
                  
                  // For collection/product templates
                  const isOnCollectionProductTemplate = (window.analyzify?.shopify_template === 'collection' || window.analyzify?.shopify_template === 'product');
                  if (isOnCollectionProductTemplate && window.analyzify?.gtmRemoveFromWishList) {
                    window.analyzify.gtmRemoveFromWishList(productInput || { id: productId }, variantId || null);
                  }
                } catch (err) {
                  window.analyzify.log('Wishlist remove listener error', 'an_find_elem', 'swym');
                }
              }
            );
          }
       } catch (err) {
         window.analyzify.log('Error attaching Swym listener', 'an_find_elem', 'swym');
       }
     }
   });

// ========== IMAGE SLIDER DETECTION FOR ee_select_image ==========

if (window.analyzify.shopify_template === "product") {

  document.addEventListener("click", function(event) {
    if (!window.analyzify || window.innerWidth < 768) return;
    
    let path = event.path || (event.composedPath && event.composedPath()) || [event.target];
    
    // For select_image conflict detection, only check the clicked element and its immediate parent
    // to avoid false positives when clicking images inside product forms
    const limitedPath = path.slice(0, 3); // clicked element + 2 immediate parents
    
    // Check if this click is for specific events that should NOT trigger select_image
    const atcElem = window.analyzify.findElemInPath(limitedPath, window.analyzify.addtocart_btn_attributes);
    const variantElem = window.analyzify.findElemInPath(limitedPath, window.analyzify.variant_btn_attributes);
    const wishlistElem = window.analyzify.findElemInPath(limitedPath, window.analyzify.wishlist_btn_attributes);
    const removeFromWishlistElem = window.analyzify.findElemInPath(limitedPath, window.analyzify.remove_from_wishlist_btn_attributes);
    
    // Skip select_image if this is a variant change, add to cart, add to wishlist, or remove from wishlist button
    if (atcElem || variantElem || wishlistElem || removeFromWishlistElem) {
      window.analyzify.log('🚫 Skipping select_image - button is for variant/cart/wishlist action', 'an_find_elem', 'select_image_skip');
      return;
    }
    
    const imageSliderElem = window.analyzify.findElemInPath(path, window.analyzify.imageSliderBtnAttribute);
    
    if (imageSliderElem) {
        window.analyzify.log('✅ Triggering select_image - no conflicting buttons found', 'an_find_elem', 'desktop_click');
        window.analyzify.gtmSelectImage(imageSliderElem);
    }
  });

  // Mobile swiper detection 
  if (window.innerWidth < 768) {
    const initSwiperListeners = () => {
      const swiperSelectors = window.analyzify.imageSliderBtnAttribute.selectors;
      let swiperContainer = null;
      
      for (const selector of swiperSelectors) {
        swiperContainer = document.querySelector(selector);
        if (swiperContainer) {
          window.analyzify.log(`Found swiper container: ${selector}`, 'an_find_elem', 'swiper_listeners');
          break;
        }
      }
      
      if (swiperContainer && swiperContainer.swiper) {
        const swiper = swiperContainer.swiper;
        window.analyzify.log('Swiper instance found, adding event listeners', 'an_find_elem', 'swiper_listeners');
        
        swiper.on('slideChangeTransitionEnd', function() {
          const activeSlide = this.slides[this.activeIndex];
          if (activeSlide && window.analyzify.gtmSelectImage) {
            window.analyzify.log('📱 Triggering gtmSelectImage via swiper slideChangeTransitionEnd (mobile)', 'an_find_elem', 'swiper_listeners');
            window.analyzify.gtmSelectImage(activeSlide);
          }
        });
        
        return true;
      } else if (swiperContainer) {
        window.analyzify.log('Swiper container found but no swiper instance yet, retrying...', 'an_find_elem', 'swiper_listeners');
        return false;
      } else {
        window.analyzify.log('No swiper container found', 'an_find_elem', 'swiper_listeners');
        return false;
      }
    };

    const waitForSwiper = (attempts = 0, maxAttempts = 10) => {
      if (attempts >= maxAttempts) {
        window.analyzify.log('Max swiper init attempts reached', 'an_find_elem', 'swiper_listeners');
        return;
      }
      
      if (!initSwiperListeners()) {
        const delay = Math.min(200 * (attempts + 1), 1500);
        setTimeout(() => waitForSwiper(attempts + 1, maxAttempts), delay);
      }
    };

    document.addEventListener('DOMContentLoaded', function() {
      waitForSwiper();
    });
    
    // If document is already loaded, fire immediately
    if (document.readyState !== 'loading') {
      waitForSwiper();
    }
  }
}

// ========== FILTER URL CHANGE DETECTION FOR ee_detail_filter ==========

if (window.analyzify.shopify_template === "collection" || window.analyzify.shopify_template === "search") {
  let previousUrl = window.location.href;
  let isInitialLoad = false;

  const getLastAddedFilter = (currentUrl, previousUrl) => {
    try {
      const currentParams = new URLSearchParams(new URL(currentUrl).search);
      const previousParams = new URLSearchParams(new URL(previousUrl).search);
      
      const currentFilters = [];
      for (const [key, value] of currentParams.entries()) {
        if (key.startsWith('filter.')) {
          currentFilters.push(`${key}=${value}`);
        }
      }
      
      const previousFilters = [];
      for (const [key, value] of previousParams.entries()) {
        if (key.startsWith('filter.')) {
          previousFilters.push(`${key}=${value}`);
        }
      }
      
      const newFilters = currentFilters.filter(f => !previousFilters.includes(f));
      
      if (newFilters.length > 0) {
        const lastFilter = newFilters[newFilters.length - 1];
        const filterValue = lastFilter.split('=')[1];
        return decodeURIComponent(filterValue).replace(/\+/g, ' ');
      }
      
      const removedFilters = previousFilters.filter(f => !currentFilters.includes(f));
      if (removedFilters.length > 0) {
        const lastRemovedFilter = removedFilters[removedFilters.length - 1];
        const filterValue = lastRemovedFilter.split('=')[1];
        return `removed:${decodeURIComponent(filterValue).replace(/\+/g, ' ')}`;
      }
      
      const currentSort = currentParams.get('sort_by');
      const previousSort = previousParams.get('sort_by');
      
      if (currentSort !== previousSort && currentSort) {
        return decodeURIComponent(currentSort).replace(/\+/g, ' ');
      }
      
      return 'filter_applied';
    } catch (error) {
      console.error('Error comparing URLs for filter detection:', error);
      return 'filter_applied';
    }
  };
  
  // Monitor URL changes
  const checkUrlChange = () => {
    const currentUrl = window.location.href;
    
    if (currentUrl !== previousUrl && !isInitialLoad) {
      if (currentUrl.includes('filter.') || currentUrl.includes('sort_by=')) {
        window.analyzify.log('Filter URL change detected', 'an_find_elem', 'filter_detection');
        
        const lastAddedFilter = getLastAddedFilter(currentUrl, previousUrl);
        
        if (window.analyzify.gtmDetailFilter) {
          window.analyzify.gtmDetailFilter({
            currentUrl,
            previousUrl,
            lastAddedFilter
          });
        }
      }
      
      previousUrl = currentUrl;
    }
    
    isInitialLoad = false;
  };
  
  // Listen for URL changes
  const originalPushState = history.pushState;
  history.pushState = function(...args) {
    const result = originalPushState.apply(history, args);
    setTimeout(checkUrlChange, 100);
    return result;
  };
  
  const originalReplaceState = history.replaceState;
  history.replaceState = function(...args) {
    const result = originalReplaceState.apply(history, args);
    setTimeout(checkUrlChange, 100);
    return result;
  };
  
  // Listen for popstate (browser back/forward)
  window.addEventListener('popstate', () => setTimeout(checkUrlChange, 100));
  
  // Initial check on page load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(checkUrlChange, 500);
  });
  
  // If document is already loaded, fire immediately
  if (document.readyState !== 'loading') {
    setTimeout(checkUrlChange, 500);
  }
}


